<template>
    <div class="d-flex flex-column">
        <div v-show="showConfirm == true">
            <p>
                Thank you for confirming your Ultra Librarian account
            </p>
            <p>
                <a href @click.prevent="signIn">Return to your previous page</a>
            </p>
        </div>
        <div v-show="showFailure == true">
            <p>
                Your Ultra Librarian Account cannot be activated at this time, please try again later.
            </p>
            <p>
                <a href @click.prevent="signIn">Return to your previous page</a>
            </p>
        </div>
    </div>
</template>

<script>
    import accountApiClient from '@/services/apiServices/accountApiClient'
    import { mapActions, mapState } from 'vuex'

    export default {
        name: 'Home',
        data() {
            return {
                showConfirm: false,
                showFailure: false
            }
        },
        methods: {
            ...mapActions('oidcStore', [
                'authenticateOidc'
            ]),
            ...mapState({
                instance: state => state.instance,
            }),
            signIn: function () {
                var configContent = JSON.parse(process.env.VUE_APP_OIDC_OPTIONS);
                var localOptions = {
                    extraQueryParams: {
                        "Base-Url": configContent.baseurl + this.$route.params.instance,
                        "App-Type": configContent.apptype,
                        "Custom-View": configContent.customView
                    }
                };
                this.authenticateOidc({ redirectPath: this.$route.path, options: localOptions });
            }
        },
        beforeMount: async function () {
            await this.$router.isReady();
            //confirm query items exist
            if (this.$route.query.userId) {
                var confirmResult = await accountApiClient.ConfirmEmail(this.$route.query.userId, this.$route.query.code);
                //Generate a real response
                if (confirmResult.status == 200 && confirmResult.data.success == true) {
                    this.showConfirm = true;
                    this.showFailure = false;
                } else {
                    this.showConfirm = false;
                    this.showFailure = true;
                }
            } else {
                this.$router.push({ name: "Home" });
            }
        }
    };
</script>

<style scoped>
</style>